import { render, staticRenderFns } from "./MainGroupbuyList.vue?vue&type=template&id=516d2741&"
import script from "./MainGroupbuyList.vue?vue&type=script&lang=js&"
export * from "./MainGroupbuyList.vue?vue&type=script&lang=js&"
import style0 from "./MainGroupbuyList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports